module.exports = __webpack_public_path__ + "media/common/text-da-dt-f9d2f4c3.svg";